import { useSiteConfigStore } from '@/stores/siteConfig'
import { computed } from 'vue'

/**
 * Composable for accessing site configuration from Pinia store
 * Replaces ConfigMixin for Composition API components
 *
 * @returns {Object} Configuration object with reactive computed properties
 * @returns {ComputedRef} config - Site configuration object
 * @returns {ComputedRef} verbiage - Site verbiage/text content
 * @returns {ComputedRef} clientResourcesUrl - URL for client resources (logos, etc.)
 */
export function useConfig() {
  const siteConfigStore = useSiteConfigStore()

  return {
    config: computed(() => siteConfigStore.config),
    verbiage: computed(() => siteConfigStore.verbiage),
    clientResourcesUrl: computed(() => siteConfigStore.clientResourcesUrl)
  }
}
